import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: '9973b7d9-2998-43c5-b53e-98af7dc9f22d',
  ENV: 'inzinzac',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr',
  matomoSiteId: 66,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
